<template>
  <div class="report-poster-center">
    <!-- 顶部用户信息和设置图标 -->
    <header class="header">
      <!-- 左侧侧边栏展开按钮 -->
      <div class="sidebar-toggle">
        <!-- <img
          src="https://trae-api-cn.mchost.guru/api/ide/v1/text_to_image?prompt=hamburger%20menu%20icon%20simple&image_size=square"
          alt="展开侧边栏"
          class="sidebar-icon"
        /> -->
      </div>

      <!-- 中间企业logo -->
      <div class="logo">
        <!-- <img
          src="https://static.xchengtech.cn/8b7751e5e818402fbc4f9ffee0540bec.png"
          alt="企业logo"
          class="logo-img"
        /> -->
      </div>

      <!-- 右侧用户信息 -->
      <div class="user-info">
        <!-- <span class="nickname">{{ wxUserInfo.nickname }}</span> -->
        <van-popover
          v-model="showPopover"
          trigger="click"
          :actions="actions"
          @select="onSelect"
          placement="bottom-end"
          class="user-popover"
        >
          <template #reference>
            <img class="avatar" :src="wxUserInfo.headimgurl || 'https://static.xchengtech.cn/tx_default.png'" alt="" />
          </template>
        </van-popover>
      </div>
    </header>

    <!-- 页面中心轮播图 -->
    <div class="carousel-container">
      <Swiper ref="swiper" class="swiper" :options="swiperOption">
        <!-- 轮播图内容 -->
        <SwiperSlide v-for="(item, index) in swiperData" :key="index">
          <div class="swiper-slide-box">
            <img
              :src="item.posterUrl"
              :alt="item.alt"
              @click.stop="handleSlideClick($event, item.posterUrl)"
            />
          </div>
        </SwiperSlide>
        <!-- 轮播图指示器 -->
        <div slot="pagination" class="swiper-pagination"></div>
      </Swiper>
    </div>
    <!-- 查看我的订单按钮 -->
    <div class="share-btn" @click="toPage('companyRepByReport')" v-show="swiperData.length > 0">
      <span
        ><img
          src="https://static.xchengtech.cn/65a5dfe11c60432e88b98e7ffa9092d1.png"
          alt=""
        />我的订单</span
      >
    </div>

    <!-- 修改密码弹窗 -->
    <van-dialog
      v-model="changePasswordDialogShow"
      class="changePasswordDialogShow"
      :show-confirm-button="false"
    >
      <div class="title">修改密码</div>
      <van-field
        v-model="editForm.phone"
        label="手机号"
        type="tel"
        placeholder="请输入手机号"
      />
      <van-field
        v-model="editForm.code"
        center
        clearable
        label="短信验证码"
        placeholder="请输入验证码"
      >
        <template #button>
          <van-button @click="toGetCode" size="small" type="primary">{{
            codeTxt
          }}</van-button>
        </template>
      </van-field>
      <van-field
        v-model="editForm.password1"
        label="新密码"
        placeholder="请输入新密码"
      />
      <van-field
        v-model="editForm.password2"
        label="确认密码"
        placeholder="请再次输入新密码"
      />
      <div class="btn">
        <span @click="changePasswordCancel">取消</span>
        <span @click="changePasswordConfirm">确认</span>
      </div>
    </van-dialog>
  </div>
</template>

<script>
import "swiper/css/swiper.css";
import { Swiper, SwiperSlide } from "vue-awesome-swiper";
import { Popover, Toast, Dialog, Field, Notify, ImagePreview } from "vant";
import { updatePassBySmsCode } from "@/api/userCenter.js";
import { getToken } from "@/utils/auth.js";
import { removeToken } from "@/utils/auth.js";
import { sendSms } from "@/api/login.js";
import { updateChannelToken } from "@/api/login.js";
import { genCompanyRepoPosts } from "@/api/companyRep.js";
import Vue from "vue";
import Cookies from "js-cookie";
Vue.use(Popover);
Vue.use(Toast);
Vue.use(Dialog);
Vue.use(Field);
Vue.use(Notify);
export default {
  components: {
    Swiper,
    SwiperSlide,
  },
  mounted() {
    // 判断是否登录
    this.isLogin();
    // 监听 Swiper 点击事件
    this.$nextTick(() => {
      if (this.$refs.swiper && this.$refs.swiper.swiper) {
        this.$refs.swiper.swiper.on("click", (swiper, event) => {
          const clickedSlide = swiper.clickedSlide;
          if (clickedSlide) {
            const slideIndex = clickedSlide.getAttribute(
              "data-swiper-slide-index"
            );
            const img = this.swiperData[slideIndex].img;
            console.log("Swiper 点击事件触发", img);
            ImagePreview({
              images: [img],
              closeable: true,
            });
          }
        });
      }
    });
  },
  data() {
    return {
      // 轮播图数据
      swiperData: [],
      // 修改密码弹窗
      editForm: {
        code: "",
        password1: "",
        password2: "",
        phone: "",
      },
      codeTxt: "发送验证码",
      getCodeFlag: false,
      changePasswordDialogShow: false,
      codeTxt: "发送验证码",
      // 点击头像 展示的用户信息
      showPopover: false,
      // 通过 actions 属性来定义菜单选项
      actions: [{ text: "修改密码" }, { text: "退出登录" }],
      wxUserInfo: {},
      showUserMenu: false,
      swiperOption: {
        // loop: true,
        speed: 300,
        // autoplay: {
        //   delay: 3000,
        //   disableOnInteraction: false,
        // },
        pagination: {
          el: ".swiper-pagination",
          clickable: true,
        },
        centeredSlides: true,
        slidesPerView: 1.6,
        spaceBetween: 20,
        touchRatio: 1,
        simulateTouch: true,

        resistanceRatio: 0.85,
        slideActiveClass: "swiper-slide-active",
        slidePrevClass: "swiper-slide-prev",
        slideNextClass: "swiper-slide-next",
        // slideToClickedSlide: true,
      },
    };
  },
  methods: {
    toPage(name) {
      // 修复：避免双斜杠问题
      const path = name.startsWith('/') ? name : '/' + name;
      this.$router.push({ path });
    },
    handleSlideClick(event, img) {
      const slideElement = event.currentTarget.closest(".swiper-slide");
      if (
        slideElement &&
        slideElement.classList.contains("swiper-slide-active")
      ) {
        ImagePreview({
          images: [img],
          closeable: true,
          swipeDuration: 0,
          className: "custom-image-preview",
        });
      }
    },
    // 判断是否登录
    isLogin() {
      // 已登录 获取微信信息
      if (getToken()) {
        // 从Cookie中获取用户名
        const wxUserInfoStr = Cookies.get("wxUserInfo");
        this.wxUserInfo = wxUserInfoStr ? JSON.parse(wxUserInfoStr) : null;
        console.log("this.wxUserInfo", this.wxUserInfo);
        // 展示loading
        Toast.loading({
          duration: 0, // 持续展示 toast
          forbidClick: true,
          message: "加载中",
          overlay: true,
        });
        // 获取海报数据
        genCompanyRepoPosts()
          .then((res) => {
            this.swiperData = res;
            Toast.clear();
          })
          .catch(() => {
            Toast.clear();
          });
      }
      // 没登陆 跳转至指定登录页
      else {
        this.$router.push({ path: "/login" });
      }
    },
    // 点击用户头像 展示用户菜单
    onSelect(action) {
      if (action.text === "修改密码") {
        this.showUserMenu = false;
        this.changePasswordDialogShow = true;
      } else if (action.text === "退出登录") {
        this.showUserMenu = false;
        this.logout();
      }
    },
    // 退出登录
    logout() {
      Dialog.confirm({
        title: "提示",
        message: "确认注销登录吗?",
        confirmButtonColor: "#3776ff",
      })
        .then(() => {
          Toast.loading({
            duration: 0, // 持续展示 toast
            forbidClick: true,
            message: "加载中",
          });
          updateChannelToken({ token: null })
            .then((res) => {
              console.log("res", res);
              Toast.clear();
              removeToken();
              this.$router.push({ path: "/login" });
            })
            .catch((err) => {
              removeToken();
              this.$router.push({ path: "/login" });
              console.log("err", err);
              Toast.clear();
            });
        })
        .catch(() => {
          // on cancel
        });
    },
    // 修改密码弹窗 确认事件
    changePasswordConfirm() {
      if (!this.editForm.phone) {
        Notify({ type: "danger", message: "请填写手机号" });
        return false;
      }
      if (!this.editForm.code) {
        Notify({ type: "danger", message: "请填写短信验证码" });
        return false;
      }
      if (!this.editForm.password1) {
        Notify({ type: "danger", message: "请填写新密码" });
        return false;
      }
      if (this.editForm.password1.length < 6) {
        Notify({ type: "danger", message: "密码长度过短，请设置六位数密码" });
        return false;
      }
      if (!this.editForm.password2) {
        Notify({ type: "danger", message: "请再次填写新密码" });
        return false;
      }
      if (this.editForm.password1 != this.editForm.password2) {
        Notify({ type: "danger", message: "两次密码不相同" });
        return false;
      }
      let body = {
        code: this.editForm.code,
        password: this.editForm.password2,
        phone: this.editForm.phone,
      };
      Toast.loading({
        duration: 0, // 持续展示 toast
        forbidClick: true,
        message: "加载中",
      });
      updatePassBySmsCode(body)
        .then((res) => {
          Toast.clear();
          Notify({
            type: "success",
            message: "密码修改成功,请重新登录",
          });
          removeToken();
          this.$router.push({ path: "/login" });
        })
        .catch((err) => {
          Toast.clear();
          console.log("err", err);
        });
    },
    // 修改密码弹窗 取消事件
    changePasswordCancel() {
      this.editForm = {
        code: "",
        password1: "",
        password2: "",
        phone: "",
      };
      this.changePasswordDialogShow = false;
    },
    // 修改密码弹窗 获取验证码
    toGetCode() {
      // 防止频繁点击
      if (this.getCodeFlag) return false;
      if (!this.editForm.phone) {
        Notify({ type: "danger", message: "请输入您的手机号" });
        return false;
      }
      Toast.loading({
        message: "加载中...",
        forbidClick: true,
        duration: 0,
      });
      sendSms(this.editForm.phone)
        .then((res) => {
          Toast.clear();
          Notify({
            type: "success",
            message: "验证码已发送，请留意您的手机短信",
          });
          this.phoneCodeInterval();
        })
        .catch((err) => {
          Toast.clear();
          Notify({ type: "danger", message: "验证码发送失败" });
        });
    },
    // 修改密码弹窗 验证码文本倒计时
    phoneCodeInterval() {
      let time = 60;
      this.getCodeFlag = true;
      let v = setInterval(() => {
        time = time - 1;
        this.codeTxt = time + " s " + "重新获取";
        if (time == 0) {
          clearInterval(v);
          this.getCodeFlag = false;
          this.codeTxt = "获取验证码";
        }
      }, 1000);
    },
  },
};
</script>
<style scoped>
.report-poster-center {
  min-height: 100vh;
  background: url("https://static.xchengtech.cn/4f0f93e6d83d4eda83abca7249149632.jpg");
  background-repeat: no-repeat;

  background-size: 100% auto;
}

/* 顶部样式 */
.header {
  display: flex;
  align-items: center;
  padding: 4vw 4vw 20vw 4vw;
  position: relative;
}

/* 左侧侧边栏展开按钮 */
.sidebar-toggle {
  padding: 8px;
  cursor: pointer;
  z-index: 1;
}

.sidebar-icon {
  width: 24px;
  height: 24px;
}

/* 中间企业logo */
.logo {
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
}

.logo-img {
  height: 32px;
  object-fit: contain;
  display: block;
}

/* 右侧用户信息 */
.user-info {
  display: flex;
  align-items: center;
  gap: 3vw;
  margin-left: auto;
  z-index: 1;
  height: 10vw;
}

.avatar {
  /* margin-right: 2vw; */
  display: block;
  width: 10vw;
  height: 10vw;
  border-radius: 50%;
  object-fit: cover;
  cursor: pointer;
}

.nickname {
  font-size: 4vw;
  font-weight: 500;
  color: #333333;
}

/* 轮播图样式 */
.carousel-container {
  flex: 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}

.swiper {
  width: 100%;
  border-radius: 16px;
  position: relative;
  overflow: hidden;
  /* 添加左右遮罩，使边缘更加圆润 */
}

.swiper:before,
.swiper:after {
  content: "";
  position: absolute;
  top: 0;
  bottom: 0;
  width: 20vw;
  z-index: 10;
  pointer-events: none;
}

.swiper-slide {
  width: 60%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  opacity: 0.6;
  will-change: transform, opacity;
  transition: transform 0.3s ease, opacity 0.3s ease;
}

.swiper-slide-active {
  opacity: 1;
  transform: scale(1);
}

.swiper-slide-active + .swiper-slide {
  transform: scale(0.85);
}

.swiper-slide-prev {
  transform: scale(0.85);
}

.swiper-slide-box {
  padding: 12vw 0;
}

.swiper-slide img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
  cursor: pointer;
}

.swiper-pagination-bullet {
  width: 2vw;
  height: 2vw;
  border-radius: 50%;
  background-color: white;
  opacity: 1;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
}

.swiper-pagination-bullet-active {
  background-color: #3776ff;
}

.share-btn {
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 4vw 4vw;
}
.share-btn span {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 1vw;
  background-image: linear-gradient(90deg, #3796ff, #1b5dd9);
  color: white;
  /* font-weight: 600; */
  border-radius: 14px;
  font-size: 4.4vw;
  /* font-weight: 600; */
  padding: 4vw 0;
}
.share-btn img {
  display: block;
  width: 5vw;
}

.user-popover {
}
.changePasswordDialogShow .title {
  padding: 6vw 0 3vw 0;
  text-align: center;
  font-weight: 600;
}

.changePasswordDialogShow .btn {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  text-align: center;
  align-items: center;
}

.changePasswordDialogShow .btn span:nth-of-type(1) {
  border-right: 1px solid #ebedf0;
}

.changePasswordDialogShow .btn span:nth-of-type(2) {
  display: block;
  padding: 4vw 0;
  color: #3776ff;
}
</style>


// WEBPACK FOOTER //
// src/view/reportCommon/reportPosterCenter.vue